"use client";

import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const faqs = [{
  question: "What bathroom remodel services can I request a quote for?",
  answer: "Bathroom remodel services can include full bathroom remodels, shower remodels, tub updates, tile, flooring, vanities, fixtures, lighting, storage, layout changes, and accessibility updates."
}, {
  question: "Can I request a quote for only a shower or tub update?",
  answer: "Yes. You can request a quote for a smaller bathroom update such as a shower remodel, tub replacement, tub-to-shower conversion, shower surround, shower tile, or updated fixtures."
}, {
  question: "Can bathroom remodel services include tile, flooring, and vanities?",
  answer: "Yes. Bathroom remodel projects can include tile, flooring, vanities, sinks, faucets, mirrors, countertops, lighting, cabinet hardware, and other fixture updates."
}, {
  question: "Do bathroom remodel services in Lakeland require permits?",
  answer: "Permit needs can vary by project. Bathroom remodels involving plumbing, electrical, structural changes, or major layout updates may require permits."
}, {
  question: "How do I request a bathroom remodel quote?",
  answer: "Submit the quote form with your name, phone number, and project notes. After that, you can review next steps for your bathroom remodel."
}];
export default function BathroomRemodelFaq() {
  return <section id="bathroomremodelfaq" className="bg-background py-16 md:py-24">
      <div className="mx-auto max-w-3xl px-6">
        <div className="mb-12 text-center">
          <Badge variant="secondary" className="mb-4">
            FAQ
          </Badge>
          <h2 className="font-default text-3xl font-bold tracking-tight text-foreground md:text-4xl">
            Bathroom Remodel Service Questions
          </h2>
          <p className="mt-4 text-muted-foreground">
            Find answers to common questions about bathroom remodeling services in Lakeland, FL and nearby Polk County areas.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full">
          {faqs.map((faq, i) => <AccordionItem key={i} data-index={i} value={`item-${i}`}>
              <AccordionTrigger className="text-left font-default text-base font-semibold">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground leading-relaxed">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>

        <div className="mt-12 flex flex-col items-center justify-center gap-4 text-center sm:flex-row">
          <Button asChild size="lg" className="w-full sm:w-auto">
            <Link to="/ContactPage">Request a Free Quote</Link>
          </Button>
          <Button asChild variant="outline" size="lg" className="w-full sm:w-auto">
            <Link to="/contact/#quote">Get a free quote</Link>
          </Button>
        </div>
      </div>
    </section>;
}